import { useParams } from "react-router-dom";
import {
  useDocumentData,
  useCollectionData,
} from "react-firebase-hooks/firestore";
import { 
  doc, 
  collection, 
  setDoc, 
  addDoc, 
  serverTimestamp,
  query,
  orderBy,
  limit
} from "firebase/firestore";
import { useAuthUserDataContext } from "hooks/useAuthUserData/useAuthUserData";
import { firestore } from "hooks/useFirebase";

export const useFirebaseRef = () => {
  const { sessionId } = useParams();

  return !sessionId ? null : doc(firestore, `oko-server/${sessionId}`);
};

export const useOkoLesson = () => {
  const docRef = useFirebaseRef();
  const { authUserData } = useAuthUserDataContext();

  const [lesson, loading, error] = useDocumentData(docRef, { idField: "id" });

  const update = (data) => {
    if (!docRef) return Promise.reject(new Error("Document reference is null"));
    return setDoc(docRef, data, { merge: true });
  };

  const say = ({ phrase, useLocal = false }) => {
    update({
      say: {
        id: Math.random().toString(36).slice(-6),
        createdAt: serverTimestamp(),
        creatorId: authUserData?.id,
        phrase,
        useLocal,
      },
    });
  };

  const eventsCollectionRef = docRef
    ? collection(firestore, docRef.path, "events")
    : null;
  const eventsQuery = eventsCollectionRef
    ? query(eventsCollectionRef, orderBy("createdAt", "desc"), limit(20))
    : null;

  let [events] = useCollectionData(
    eventsQuery,
    {
      idField: "id",
    }
  );

  const addEvent = (data, id) => {
    if (!eventsCollectionRef) return Promise.reject(new Error("Events collection reference is null"));
    
    if (!id) id = "i" + Math.random().toString(36).substr(2, 9);

    return addDoc(eventsCollectionRef, {
      ...data,
      createdAt: serverTimestamp(),
    });
  };

  return { events, lesson, loading, error, addEvent, update, say };
};
